import { useLocation } from 'react-router';
import { Page } from '../components/layout';
import { useT } from '../i18n';
import { PrivacyPolicy } from './privacy/PrivacyPolicy';

/** Persónuverndarstefna inside the app (/privacy). The policy itself is shared with the pre-sign-in screens. */
export default function PrivacyScreen() {
  const t = useT();
  const location = useLocation();
  return (
    <Page title={t('settings.privacy.title')} back={location.key === 'default' ? '/settings' : true}>
      <PrivacyPolicy />
    </Page>
  );
}
